import { portalHomeImages } from "@/components/PortalHome/portalHomeAssets";
import { resolveBundledAssetUrl } from "@/utils/resolveBundledAssetUrl";

const VISUAL_TYPES = [
  "rain_tire",
  "road_car",
  "trucks_road",
  "truck_side",
  "logistics_map",
  "motorcycle",
  "wet_wheel",
];

const defaultDescription = {
  "pl-PL":
    "W tegorocznej edycji Pasji Bridgestone mamy aż 120 nagród. Twój stan konta pozwala Ci odebrać aż 88 z nich!",
  "de-DE":
    "In der diesjährigen Bridgestone Passion Edition warten 120 Prämien auf Sie.",
  "cs-CZ":
    "V letošní edici Bridgestone Passion je k dispozici 120 odměn.",
  "sk-SK":
    "V tohtoročnej edícii Bridgestone Passion je k dispozícii 120 odmien.",
  "hu-HU":
    "Az idei Bridgestone Passion kiadásban 120 jutalom vár.",
};

const longDescriptionExtra = {
  "pl-PL":
    "Promocja nalicza punkty automatycznie po zakupie kwalifikujących się opon. Upewnij się, że faktury są zgłoszone w systemie w ciągu 14 dni od zakupu.",
  "de-DE":
    "Die Aktion vergibt Punkte automatisch nach dem Kauf qualifizierender Reifen.",
  "cs-CZ":
    "Akce připisuje body automaticky po nákupu kvalifikovaných pneumatik.",
  "sk-SK":
    "Akcia pripisuje body automaticky po nákupe kvalifikovaných pneumatík.",
  "hu-HU":
    "Az akció a jogosult gumák vásárlása után automatikusan ír jóvá pontokat.",
};

const rulesDefault = {
  "pl-PL": [
    "Promocja dotyczy wybranych rozmiarów i marek z tabeli dopłat.",
    "Minimalna liczba sztuk do aktywacji punktów zależy od progu w koncie dealera.",
    "Punkty za zakupy z okresu promocji są widoczne po weryfikacji faktury.",
  ],
  "de-DE": [
    "Die Aktion gilt für ausgewählte Größen und Marken.",
    "Punkte werden nach Rechnungsprüfung gutgeschrieben.",
  ],
};

const promotionCopy = [
  {
    slug: "podwojne-punkty-ecopia-elite-60",
    name: {
      "pl-PL": "Podwójne punkty za opony Ecopia Elite Serii 60",
      "de-DE": "Doppelte Punkte für Ecopia Elite Serie 60 Reifen",
    },
    amount_type: "multiply",
    promotion_value: 2,
    type: "no_sign_in_required",
    featured: true,
    status: "active",
    highlights: [
      {
        label: { "pl-PL": "Marki", "de-DE": "Marken" },
        value: { "pl-PL": "Bridgestone, Firestone", "de-DE": "Bridgestone, Firestone" },
      },
      {
        label: { "pl-PL": "Okres", "de-DE": "Zeitraum" },
        value: { "pl-PL": "01.01 – 31.12.2026", "de-DE": "01.01 – 31.12.2026" },
      },
    ],
  },
  {
    slug: "dodatkowe-punkty-cel-zakupowy",
    name: {
      "pl-PL": "Dodatkowe punkty za realizację celu zakupowego",
      "de-DE": "Zusätzliche Punkte für das Erreichen des Einkaufsziels",
    },
    amount_type: "add",
    promotion_value: 1,
    type: "sign_in_required",
    signed_in: false,
    featured: true,
    status: "active",
    highlights: [
      {
        label: { "pl-PL": "Wymagany zapis", "de-DE": "Anmeldung erforderlich" },
        value: { "pl-PL": "Tak", "de-DE": "Ja" },
      },
    ],
  },
  {
    slug: "bonus-letnia-premia-osobowe",
    name: {
      "pl-PL": "Letnia premia — opony osobowe 16–18″",
      "de-DE": "Sommerbonus — Pkw-Reifen 16–18″",
    },
    amount_type: "add",
    promotion_value: 3,
    type: "no_sign_in_required",
    status: "active",
  },
  {
    slug: "mnoznik-punktow-floty",
    name: {
      "pl-PL": "Mnożnik punktów dla floty ciężarowej",
      "de-DE": "Punktemultiplikator für Lkw-Flotten",
    },
    amount_type: "multiply",
    promotion_value: 1.5,
    type: "sign_in_required",
    signed_in: true,
    status: "active",
  },
  {
    slug: "start-sezonu-motocyklowe",
    name: {
      "pl-PL": "Start sezonu — opony motocyklowe",
      "de-DE": "Saisonstart — Motorradreifen",
    },
    amount_type: "add",
    promotion_value: 2,
    type: "no_sign_in_required",
    status: "ending_soon",
  },
  {
    slug: "logistyka-mapowa-premia",
    name: {
      "pl-PL": "Premia logistyczna — zakupy hurtowe",
      "de-DE": "Logistikprämie — Großabnahmen",
    },
    amount_type: "multiply",
    promotion_value: 2,
    type: "no_sign_in_required",
    status: "active",
  },
  {
    slug: "podwojne-punkty-ecopia-elite-60-q3",
    name: {
      "pl-PL": "Podwójne punkty za opony Ecopia Elite Serii 60",
      "de-DE": "Doppelte Punkte für Ecopia Elite Serie 60 Reifen",
    },
    amount_type: "multiply",
    promotion_value: 2,
    type: "sign_in_required",
    signed_in: true,
    status: "active",
  },
  {
    slug: "szybki-zwrot-punktow-van",
    name: {
      "pl-PL": "Szybki zwrot punktów — opony dostawcze",
      "de-DE": "Schnelle Punkte — Transporterreifen",
    },
    amount_type: "add",
    promotion_value: 4,
    type: "no_sign_in_required",
    status: "planned",
    is_active: false,
  },
];

export const portalPromotionsApiMock = promotionCopy.map((item, index) => {
  const imageSrc = portalHomeImages.promotions[index];
  const resolvedImage = resolveBundledAssetUrl(imageSrc) || imageSrc;

  return {
    id: index + 1,
    slug: item.slug,
    type: item.type,
    promotion_start: "2026-01-01T00:00:00+00:00",
    promotion_end: "2026-12-31T23:59:59+00:00",
    name: item.name,
    description: { ...defaultDescription },
    full_text: {
      ...defaultDescription,
      ...longDescriptionExtra,
    },
    long_description: {
      ...defaultDescription,
      ...longDescriptionExtra,
    },
    rules: { ...rulesDefault },
    image: null,
    image_url: resolvedImage,
    promotion_value: item.promotion_value,
    amount_type: item.amount_type,
    signed_in: item.signed_in ?? false,
    visualType: VISUAL_TYPES[index],
    featured: item.featured ?? false,
    is_active: item.is_active !== false,
    status: item.status ?? "active",
    highlights: item.highlights ?? [],
  };
});

export function fetchPortalPromotionsMock() {
  return Promise.resolve(
    portalPromotionsApiMock.map((promotion) => ({ ...promotion })),
  );
}
